import { API } from "aws-amplify";

const index = async (params) => {
    let myInit = { // OPTIONAL
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        queryStringParameters: params
    };
    let items = await API.get("InasakuAPI", "/inasaku/logs", myInit);

    return items;
};

const del = async (params) => {
    let myInit = {
        response: true, // OPTIONAL (return the entire Axios response object instead of only response.data)
        body: {
            data: params
        }, // replace this with attributes you need
        headers: {} // OPTIONAL
    };

    let res = await API.del("InasakuAPI", `/inasaku/logs`, myInit);

    return res;
};

export default {
    index: index,
    del: del,
};
